import createReReSelector from 're-reselect';
import { createSelector } from 'reselect';

import {
    getRecommendationIdContext,
    RecommendationСharacterWeight
} from '../../service/RecommendationsHelpers/RecommendationsHelpers';
import { EditBannersState, GroupBanners } from '../../typings/bannersEditState';
import { banners, groups } from '../../typings/common';
import { GroupId } from '../../typings/groups';
import {
    EditPageRecommendationsData,
    Recommendation,
    RecommendationModalType,
    RecommendationsAgregator,
    RecommendationsModalState
} from '../../typings/recommendations';
import { State } from '../../typings/state';
import { getRecommendationAgregatorData } from '../recommendations';

export const getRecommendationsDataForEditBanners = createReReSelector(
    (state: State, groupId: string) => selectEditedBannerRecommendationSet(state, groupId),
    (recommendationSet: EditPageRecommendationsData): RecommendationsAgregator => {
        return getRecommendationAgregatorData(recommendationSet, banners);
    }
)((state, groupId) => groupId);

export const getBannerModalRecommendations = createSelector(
    (state: State, id: string) => selectEditedBannerRecommendationSet(state, id),
    (state: State) => state.editBanners,
    (state: State) => state.editBanners.groupBannersList,
    (state: State, id: string) => id,
    (
        recommendationSet: EditPageRecommendationsData,
        editBanners: EditBannersState,
        groupBannersList: Record<string, GroupBanners>,
        id: string
    ): RecommendationsModalState => {
        if (!recommendationSet) {
            return {
                isVisible: false,
                data: [],
                headerHint: ''
            };
        }

        const { recommendations } = recommendationSet;
        const data: Array<RecommendationModalType> = recommendations
            .map((recommendation: Recommendation) => {
                const { keys } = recommendation;
                const bid = keys[0].bid;
                const pid = keys[0].pid;

                if (bid) {
                    return {
                        title: editBanners[bid].title,
                        titleHint: getRecommendationIdContext(banners, bid),
                        recommendation: recommendation
                    };
                }

                return {
                    title: groupBannersList[pid].groupName,
                    titleHint: getRecommendationIdContext(groups, pid),
                    recommendation: recommendation
                };
            })
            .sort(
                (a, b) =>
                    RecommendationСharacterWeight[a.recommendation.character] -
                    RecommendationСharacterWeight[b.recommendation.character]
            );

        return {
            isVisible: true,
            data: data,
            headerHint: `${groupBannersList[id].groupName}, ${getRecommendationIdContext(groups, id)}`
        };
    }
);

export const selectEditedBannerRecommendationSet = (state: State, groupId: GroupId): EditPageRecommendationsData => {
    return state.editBanners.groupBannersRecommendations[groupId];
};
